import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface CardTitleProps {
    className?: string;
    children: ReactNode;
    icon?: ReactNode;
}

const CardTitle = ({ className, children, icon }: CardTitleProps) => {
    return (
        <h3 className={clsx('flex items-center gap-2 text-base font-semibold text-neutral-800', className)}>
            {icon && icon}
            {children}
        </h3>
    );
};

export default CardTitle;
